module.exports = __webpack_public_path__ + "static/media/logoIcone.c2b5f841.svg";